import type { ReactNode } from 'react';

interface TabPanelProps {
  value: number;
  index: number;
  children: ReactNode;
}

const TabPanel = ({ value, index, children }: TabPanelProps) => (value === index ? <>{children}</> : null);

export default TabPanel;
